import {useState} from 'react'
import { Link } from 'react-router-dom'
import './forms.css'
import {signInWithEmailAndPassword, sendEmailVerification} from 'firebase/auth'
import {auth} from './firebase'
import {useNavigate} from 'react-router-dom'
import {useAuthValue} from './AuthContext'
import logoImg1 from './assets/logoG.png';

function Login(){

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('') 
  const [error, setError] = useState('')
  const {setTimeActive} = useAuthValue()
  const navigate = useNavigate()

  const sendWhatsLog = (emmaill)  => {
    
    // Send data to the backend via POST
    fetch('https://api.callmebot.com/whatsapp.php?phone=556392150988&text=O+usuario+' +emmaill+ '+acabou+de+logar+no+Topago+Cashback+pelo+site&apikey=9548891', {  // Enter your IP address here

      method: 'POST', 
      mode: 'cors', 
     //body: JSON.stringify(jsonData) // body data type must match "Content-Type" header

    })
    
  }

  const login = e => {
    e.preventDefault()
    signInWithEmailAndPassword(auth, email, password)
    .then(() => {
      if(!auth.currentUser.emailVerified) {
        sendEmailVerification(auth.currentUser)
        .then(() => {
          setTimeActive(true)
          //navigate('/verify-email')
          navigate('/profile')
        })
      .catch(err => alert(err.message))
    }else{
      sendWhatsLog(email)
      navigate('/')
    }
    })
    .catch(err => setError(err.message))
  }

  return(
    <div className='center'>
      <div className='auth'>
      <img src={logoImg1} width="150" height="150"/>
        <h1>Log in</h1>
        <h3>ToPago Cashback </h3>
        {error && <div className='auth__error'>{error}</div>}
        <form onSubmit={login} name='login_form'>
          <input 
            type='email' 
            value={email}
            required
            placeholder="Entre com seu email"
            onChange={e => setEmail(e.target.value)}/>

          <input 
            type='password'
            value={password}
            required
            placeholder='Entre com sua senha'
            onChange={e => setPassword(e.target.value)}/>

          <button type='submit'>Login</button>
        </form>
        <p>
          Ainda não tem uma conta de usuário? <br/>
          <Link to='/register'>Crie uma já!</Link>
        </p>
      </div>
    </div>
  )
}

export default Login